import {
    ButtonFixedFooterLayout,
    ButtonPrimary,
    IconCheckRegular,
    IconChevronLeftRegular,
    NavigationBar,
    Row,
    RowList,
    Text2,
    Text3,
    ThemeVariant,
    skinVars,
    useWindowSize,
} from '@telefonica/mistica';
import React, { useEffect } from 'react';
import './index.scss';
import { useNavigate } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import navigateParams from '../../../../utils/navigation/navigateParams';
import { rehabilitateLines } from '../../../../services/BillService';
import { TrackingEvents } from '../../../../utils/dataTransformation/tracking';
import { isWebviewAndroid, isWebviewIOS } from '../../../../utils/navigation/controlDevices';
import BreadCrumbsWrapper from '../../../../components/BreadcrumbsWrapper';

const ModalRehabilitationLines: React.FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { trackingScreenView } = new TrackingEvents();
    const size = useWindowSize();

    const linesRehabilitation = () => {
        rehabilitateLines()
            .then((response: any) => {
                sendToNative(
                    '/modal-rehabilitation-lines/rehabilitation-lines-feedback',
                    'feedback-success',
                    '',
                    'SUCCESS',
                );
            })
            .catch((error) => {
                console.error('error', error);
            });
    };

    const sendToNative = (url: any, type: any, title: any, description: any) => {
        const queryParams = {
            state: description,
            title: t('rehabilitationLinesInfoFeedbackTitle'),
            subtitle: t('rehabilitationLinesInfoFeedbackDescription'),
        };
        if (navigateParams(type, url, queryParams, {}, '')) {
            navigate(url);
        }
    };

    useEffect(() => {
        if (!(isWebviewAndroid || isWebviewIOS)) {
            trackingScreenView();
        }
    }, []);
    return (
        <div className='rehabilitationLines-page'>
            <div
                className='rehabilitationLines-page__header'
                style={{
                    background: skinVars.colors.background,
                    borderBottom: size.width >= 1024 ? `1px solid ${skinVars.colors.divider}` : '',
                }}
            >
                {!(isWebviewAndroid || isWebviewIOS) && (
                    <>
                        <div className='rehabilitationLines-page__header-navigationBar'>
                            <NavigationBar
                                title={t('debtPaymentModalHeader')}
                                onBack={() => {
                                    navigate('/modal-debt-payment');
                                }}
                            />
                        </div>
                        <div
                            className='rehabilitationLines-page__header-return'
                            onClick={() => {
                                navigate('/modal-debt-payment');
                            }}
                        >
                            <div className='rehabilitationLines-page__header-return-icon'>
                                <IconChevronLeftRegular color={skinVars.colors.textPrimary} size={20} />
                            </div>
                            <Text2 medium color={skinVars.colors.textPrimary}>
                                {t('returnResponsive')}
                            </Text2>
                        </div>
                    </>
                )}
                <div className='rehabilitationLines-page__header-breadcrumbs'>
                    <ThemeVariant>
                        <BreadCrumbsWrapper
                            title={t('modalRehabilitationLinesButtonFooter')}
                            breadcrumbs={[
                                { title: t('invoice'), url: '/bills' },
                                { title: t('debtPaymentModalHeader'), url: '/modal-debt-payment' },
                            ]}
                        />
                    </ThemeVariant>
                </div>
            </div>
            <div className='rehabilitationLines-page__content'>
                <ButtonFixedFooterLayout
                    button={
                        <ButtonPrimary onPress={linesRehabilitation}>
                            {t('modalRehabilitationLinesButtonFooter')}
                        </ButtonPrimary>
                    }
                >
                    <div className='rehabilitationLines-page__title'>
                        <Text3 regular>{t('modalRehabilitationLinesTitle')}</Text3>
                    </div>
                    <div className='rehabilitationLines-page__list'>
                        <RowList>
                            <Row
                                title=''
                                extra={
                                    <div className='rehabilitationLines-page__extra'>
                                        <div className='rehabilitationLines-page__extra-icon'>
                                            <IconCheckRegular size={24} />
                                        </div>
                                        <div>
                                            <Text3 regular color={skinVars.colors.textPrimary}>
                                                {t('modalRehabilitationLinesRowOne')}
                                            </Text3>
                                            <Text3 regular color={skinVars.colors.textSecondary}>
                                                {t('modalRehabilitationLinesRowOneText')}
                                            </Text3>
                                        </div>
                                    </div>
                                }
                            ></Row>
                            <Row
                                asset={<IconCheckRegular size={24} />}
                                title=''
                                extra={
                                    <div>
                                        <Text3 regular color={skinVars.colors.textPrimary}>
                                            {t('modalRehabilitationLinesRowTwo')}
                                        </Text3>
                                    </div>
                                }
                            ></Row>
                            <Row
                                title=''
                                extra={
                                    <div className='rehabilitationLines-page__extra'>
                                        <div className='rehabilitationLines-page__extra-icon'>
                                            <IconCheckRegular size={24} />
                                        </div>
                                        <div>
                                            <Text3 regular color={skinVars.colors.textSecondary}>
                                                {
                                                    <Trans
                                                        i18nKey={'modalRehabilitationLinesRowThree'}
                                                        values={{ postMail: t('postMail') }}
                                                        style={{ fontWeight: '600' }}
                                                    />
                                                }
                                            </Text3>
                                            <Text3 regular color={skinVars.colors.textSecondary}>
                                                {t('modalRehabilitationLinesRowThreeText')}
                                            </Text3>
                                        </div>
                                    </div>
                                }
                            ></Row>
                        </RowList>
                    </div>
                </ButtonFixedFooterLayout>
            </div>
        </div>
    );
};

export default ModalRehabilitationLines;
